import style from './PersonnelTable.module.scss';
import className from 'classnames/bind';
import { useState } from "react";
import Tippy from '@tippyjs/react/headless';
import {Button, Icon} from "~/components";
import {PopperWrapper} from "~/components/Popper";
import {useCan} from "~/hooks";
import {Popconfirm} from "antd";
import {FontAwesomeIcon} from "../../../../components";

const cn = className.bind(style);

function PersonnelAction({item, setItemEdit, openModal, locked, unlocked}) {

	const can = {
		edit: useCan('personnelEdit'),
		editPay: useCan('personnelPay'),
		editRole: useCan('personnelRole'),
		editRoleDepartment: useCan('personnelRoleDepartment'),
		editLeader: useCan('personnelLeader'),
		switchGroup: useCan('personnelSwitchGroup'),
		resetPass: useCan('personnelPassword'),
		delete: useCan('personnelBlock'),
		probationHistory: useCan('probationHistoryView'),
		history: useCan('userHistoryView'),
		setCycle: useCan('evaluationSetCycle'),
	}

	//Chỉ thiết lập chu kỳ đánh giá cho nhân viên kinh doanh
	const canSetCycle = can.setCycle && item.role?.key === 'sales';

	const [showActionBox, setShowActionBox] = useState(false);

	const closeActionButton = () => {
		setShowActionBox(false);
	};

	const handleButtonClick = {
		pay: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('pay');
		},
		leader: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('leader');
		},
		switchGroup: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('group');
		},
		resetPass: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('password');
		},
		edit: () => {
			setItemEdit(item);
			openModal('edit');
		},
		delete: () => {
			setItemEdit(item);
			openModal('delete');
		},
		locked: () => {
			setItemEdit(item);
			locked(item)
		},
		unlocked: () => {
			setItemEdit(item);
			unlocked(item)
		},
		role: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('role');
		},
		card: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('card');
		},
		probationHistory: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('probationHistory');
		},
		history: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('history');
		},
		setCycle: () => {
			closeActionButton();
			setItemEdit(item);
			openModal('setCycle');
		}
	}

	const renderActionButton = () => {
		return (
			<PopperWrapper className={cn('action-wrapper')}>
				{(can.editRole || can.editRoleDepartment) && <Button leftIcon={Icon.briefcase} onClick={handleButtonClick.role}>Chức Vụ</Button>}
				{can.editLeader && <Button leftIcon={Icon.plusUser} onClick={handleButtonClick.leader}>Đội Nhóm</Button>}
				{can.switchGroup && <Button leftIcon={Icon.switch} onClick={handleButtonClick.switchGroup}>Phân chuyển nhóm</Button>}
				{can.resetPass && <Button leftIcon={Icon.edit} onClick={handleButtonClick.resetPass}>Reset mật khẩu</Button>}
				{can.probationHistory && <Button leftIcon={Icon.calendar} onClick={handleButtonClick.probationHistory}>Lịch sử TT - TV</Button>}
				{can.history && <Button leftIcon={Icon.hourglassClock} onClick={handleButtonClick.history}>Lịch sử thao tác</Button>}
				{canSetCycle && <Button leftIcon={Icon.calendar} onClick={handleButtonClick.setCycle}>Chu kỳ đánh giá</Button>}
				{can.delete && <Button background red noneBorder leftIcon={Icon.delete} onClick={handleButtonClick.delete}>Cho nghỉ việc</Button>}
			</PopperWrapper>
		)
	}
	return (
		<div className="table-action d-flex">
			<Button background white leftIcon={Icon.card} onClick={handleButtonClick.card}></Button>
			{can.edit && <Button background blue leftIcon={Icon.edit} onClick={handleButtonClick.edit}></Button>}
			{(can.delete && item.locked === 0) && <Popconfirm title="Khóa nhân viên" description="Bạn có chắc chắn muốn khóa nhân viên này?" onConfirm={handleButtonClick.locked}>
				<Button background yellow noneBorder leftIcon={<FontAwesomeIcon icon="fa-regular fa-user-lock" />}></Button>
			</Popconfirm>}
			{(can.delete && item.locked === 1) && <Popconfirm title="Mở Khóa nhân viên" description="Bạn có chắc chắn muốn mở khóa nhân viên này?" onConfirm={handleButtonClick.unlocked}>
				<Button background green noneBorder leftIcon={<FontAwesomeIcon icon="fa-regular fa-user-unlock" />}></Button>
			</Popconfirm>}
			{can.editPay && <Button leftIcon={Icon.landmark} onClick={handleButtonClick.pay}></Button>}
			{
				(can.editLeader || can.switchGroup || can.resetPass || can.probationHistory || can.history || canSetCycle) && <Tippy
					interactive
					visible={showActionBox}
					render={renderActionButton}
					onClickOutside={closeActionButton}
					placement="left" offset={[0, 10]}
				><div onClick={() => setShowActionBox(true)} className={cn('action-btn')}>{Icon.menuVertical}</div></Tippy>
			}

		</div>
	)
}

export default PersonnelAction;